import { makeStyles } from '@material-ui/core';

export default makeStyles((theme: any) => ({
  imageContainer: {
    margin: '7px 0',
    backgroundColor: '#EEEEEE',
    borderRadius: theme.new.sizings.border,
    '& p': {
      textTransform: 'none',
    },
  },
  icon: {
    marginRight: 10,
  },
  eyeContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '100%',
  },
}));
